{
  "version": 1,
  "asset_id": "63e924a5-9342-4f9d-99d1-aace15650fe9",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/63e924a5-9342-4f9d-99d1-aace15650fe9/hiatal-normal-1536.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/63e924a5-9342-4f9d-99d1-aace15650fe9/hiatal-normal-1536.jpg",
  "original_filename": "hiatal-normal-1536.jpg",
  "size": 177842,
  "content_type": "image/jpeg",
  "created_at": "2026-09-23T01:03:46Z"
}
